import { ScrollableCurriculumTabStrip } from "@/components/ui/scrollable-curriculum-tab-strip";
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface TaebaekProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

function TaebaekMovesOl() {
  return (
    <ol className="list-none space-y-2">
            <li className="flex">
              <span className="text-taekwondo-red mr-2">Start:</span>
              <span className="text-gray-700">Start in the Ready position</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">1.</span>
              <span className="text-gray-700">First going left...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">2.</span>
              <span className="text-gray-700">Step left with the left foot into Tiger Stance. Low Knifehand Opening Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">3a.</span>
              <span className="text-gray-700">Right Front Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">3b-c.</span>
              <span className="text-gray-700">Step down with the right foot into Right Front Stance. Double Punch - right hand then left hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">4.</span>
              <span className="text-gray-700">Then going right...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">5.</span>
              <span className="text-gray-700">Step right with the right foot to turn right 180 degrees into Tiger Stance. Low Knifehand Opening Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">6a.</span>
              <span className="text-gray-700">Left Front Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">6b-c.</span>
              <span className="text-gray-700">Step down with the left foot into Left Front Stance. Double Punch - left hand then right hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">7.</span>
              <span className="text-gray-700">TRANSITION TO THE SECOND LINE</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">8.</span>
              <span className="text-gray-700">Step left with the left foot into a Left Front Stance. Swallowform Knifehand Strike (left arm high).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">9a.</span>
              <span className="text-gray-700">Without stepping, with the right hand, twist and grab the opponent's wrist.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">9b.</span>
              <span className="text-gray-700">While pulling with the right hand, step forward into Right Front Stance. Left Punch.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">10a.</span>
              <span className="text-gray-700">Without stepping, with the left hand, twist and grab the opponent's wrist.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">10b.</span>
              <span className="text-gray-700">While pulling with the left hand, step forward into Left Front Stance. Right Punch.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">11a.</span>
              <span className="text-gray-700">Without stepping, with the right hand, twist and grab the opponent's wrist.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">11b.</span>
              <span className="text-gray-700">While pulling with the right hand, step forward into Right Front Stance. Left Punch. Kihap.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">12.</span>
              <span className="text-gray-700">SECOND LINE</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">13.</span>
              <span className="text-gray-700">First going to the right...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">14.</span>
              <span className="text-gray-700">Step with the left foot to turn 270 to the left into Right Back Stance (i.e., left foot forward). Diamond Block (right arm high).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">15.</span>
              <span className="text-gray-700">Without stepping, High Pulling Uppercut (the right hand performs an Uppercut to the opponent's chin; the left hand pulls the opponent toward you).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">16.</span>
              <span className="text-gray-700">Without stepping, Side Punch with the left hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">17.</span>
              <span className="text-gray-700">Lift the left foot into Right Crane Stance. Left Small Hinge Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">18a.</span>
              <span className="text-gray-700">Pivot clockwise on the right foot to execute a simultaneous Left Side Punch & Left Side Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">18b.</span>
              <span className="text-gray-700">Step down with the left foot into Left Front Stance. With the right elbow execute an Elbow Target Strike.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">19.</span>
              <span className="text-gray-700">Then going to the left...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">20a.</span>
              <span className="text-gray-700">Bring the left foot to the right foot, then slide the right foot to turn 180 to the right into a Closed Stance.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">20b.</span>
              <span className="text-gray-700">Step forward with the right foot to a Left Back Stance. Diamond Block (left arm high).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">21.</span>
              <span className="text-gray-700">Without stepping, High Pulling Uppercut (the left hand performs an Uppercut to the opponent's chin; the right hand pulls the opponent toward you).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">22.</span>
              <span className="text-gray-700">Without stepping, Side Punch with the right hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">23.</span>
              <span className="text-gray-700">Lift the right foot into a Left Crane Stance. Right Small Hinge Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">24a.</span>
              <span className="text-gray-700">Pivot counterclockwise on the left foot to execute a simultaneous Right Side Punch & Right Side Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">24b.</span>
              <span className="text-gray-700">Step down with the right foot into Right Front Stance. With the left elbow execute an Elbow Target Strike.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">25.</span>
              <span className="text-gray-700">BACK TO THE FIRST LINE</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">26.</span>
              <span className="text-gray-700">Bring the right foot to the left, then slide the left foot into a Right Back Stance (ie. left foot forward). Left Double Knifehand Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">27.</span>
              <span className="text-gray-700">Step forward with the right foot into a Right Front Stance. With the right arm execute a Vertical Fingertip Thrust. With the left arm execute a Pressing Block.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">28a.</span>
              <span className="text-gray-700">Pivot 180 counterclockwise and bring the right hand behind you to the rear of the right-side waist.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">28b.</span>
              <span className="text-gray-700">Stepping with the left foot turn 180 counterclockwise into Right Back Stance (i.e. left foot forward). Left Outward Backfist Strike.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">29.</span>
              <span className="text-gray-700">Step forward with the right foot into Right Front Stance. Right Punch. Kihap.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">30.</span>
              <span className="text-gray-700">FIRST LINE</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">31.</span>
              <span className="text-gray-700">First going left...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">32.</span>
              <span className="text-gray-700">Step left with the left foot into Left Front Stance. Scissors Block (right arm high).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">33a.</span>
              <span className="text-gray-700">Right Front Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">33b-c.</span>
              <span className="text-gray-700">Step down with the right foot into Right Front Stance. Double Punch - right hand then left hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">34.</span>
              <span className="text-gray-700">Then going right...</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">35.</span>
              <span className="text-gray-700">Step right with the right foot to turn right 180 into Right Front Stance. Scissors Block (left arm high).</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">36a.</span>
              <span className="text-gray-700">Left Front Kick.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">36b-c.</span>
              <span className="text-gray-700">Step down with the right foot into Left Front Stance. Double Punch - left hand then right hand.</span>
            </li>
            <li className="flex">
              <span className="text-taekwondo-red mr-2">End:</span>
              <span className="text-gray-700">Return to Ready position.</span>
            </li>
    </ol>
  );
}

export default function Taebaek({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: TaebaekProps) {
  // Show for 2nd Dan and above
  if (!['BLACK/D2', 'BLACK/D3', 'BLACK/D4', 'BLACK/D5'].includes(selectedBelt)) {
    return null;
  }

  const surface = beltTabSurfaceClass;
  const triggerClass = cn(
    "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-black/10 px-3 py-2 text-xs font-medium md:text-sm",
    surface,
    "data-[state=active]:z-10 data-[state=active]:shadow-md data-[state=active]:ring-2 data-[state=active]:ring-gray-900/40 data-[state=active]:ring-offset-2 data-[state=active]:ring-offset-gray-100",
  );

  const demoBtn =
    hasDemo?.(["taebaek"]) ? (
      <button
        type="button"
        className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["taebaek"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-2 text-lg font-semibold text-taekwondo-red md:text-xl">Taebaek</h2>
        {demoBtn && <div className="mb-3">{demoBtn}</div>}
        <Tabs defaultValue="pattern-information" className="w-full space-y-4">
          <ScrollableCurriculumTabStrip ariaLabelPrefix="Taebaek">
            <TabsTrigger value="pattern-information" className={triggerClass}>
              Pattern Information
            </TabsTrigger>
            <TabsTrigger value="details" className={triggerClass}>
              Details
            </TabsTrigger>
            <TabsTrigger value="meaning" className={triggerClass}>
              Meaning
            </TabsTrigger>
            <TabsTrigger value="key-techniques" className={triggerClass}>
              Key Techniques
            </TabsTrigger>
            <TabsTrigger value="pattern" className={triggerClass}>
              Pattern
            </TabsTrigger>
          </ScrollableCurriculumTabStrip>

          <TabsContent value="pattern-information" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Information</h4>
              <p className="mb-4 text-gray-700">
                Taebaek is named after Mount Taebaek, a symbol of the origins of Korean civilization. This pattern represents the philosophical
                principles of &quot;Hongik-Ingan&quot; (universal welfare of mankind) and the importance of contributing to human society.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="details" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Details</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Number of Movements: 26</li>
                <li>Pattern Diagram: Plus (+)</li>
                <li>Starting Position: Parallel Ready Stance</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="meaning" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Meaning</h4>
              <p className="text-gray-700">
                Taebaek means &quot;Bright Mountain&quot; and symbolizes the birthplace of Korean civilization. The pattern&apos;s movements emphasize the
                brightness of wisdom and the strength of mountains, combining fluid movements with powerful techniques.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="key-techniques" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Key Techniques</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Advanced kicking combinations</li>
                <li>Precise hand techniques</li>
                <li>Complex stance transitions</li>
                <li>Balance and control exercises</li>
                <li>Power generation methods</li>
                <li>Fluid movement patterns</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="pattern" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Movements</h4>
              <TaebaekMovesOl />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-4 rounded-lg mt-2">
      <div className="space-y-4">
        <div>
          {hasDemo?.(["taebaek"]) && (
            <button
              type="button"
              className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline mb-3"
              onClick={() => onWatchDemo?.(["taebaek"])}
            >
              Watch Demonstration Video
            </button>
          )}
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Pattern Information</h4>
          <p className="text-gray-700 mb-4">
            Taebaek is named after Mount Taebaek, a symbol of the origins of Korean civilization. This pattern 
            represents the philosophical principles of "Hongik-Ingan" (universal welfare of mankind) and the 
            importance of contributing to human society.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Meaning</h4>
          <p className="text-gray-700 mb-4">
            Taebaek means "Bright Mountain" and symbolizes the birthplace of Korean civilization. The pattern's 
            movements emphasize the brightness of wisdom and the strength of mountains, combining fluid movements 
            with powerful techniques.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Pattern Details</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Number of Movements: 26</li>
            <li>Pattern Diagram: Plus (+)</li>
            <li>Starting Position: Parallel Ready Stance</li>
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Key Techniques</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Advanced kicking combinations</li>
            <li>Precise hand techniques</li>
            <li>Complex stance transitions</li>
            <li>Balance and control exercises</li>
            <li>Power generation methods</li>
            <li>Fluid movement patterns</li>
          </ul>
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Movements</h4>
          <TaebaekMovesOl />
        </div>

        <div>
          <h4 className="font-medium text-base mb-2 text-taekwondo-red">Training Focus</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Technical precision in advanced movements</li>
            <li>Power development through proper body mechanics</li>
            <li>Balance and stability in complex techniques</li>
            <li>Smooth transitions between movements</li>
            <li>Mental focus and concentration</li>
            <li>Understanding of pattern applications</li>
          </ul>
        </div>
      </div>
    </div>
  );
} 